var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41858 18.6578L5.36907 17.0324L5.94232 17.7192L2.97116 20.1949L0 17.7192L0.57326 17.0324L2.52374 18.6578V11.1119H3.41858V18.6578Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1052 3.95312C23.5996 3.95312 24 4.35357 24 4.84797V19.1655C24 19.6599 23.5996 20.0603 23.1052 20.0603H6.99796V19.1655H23.1052V5.64581L14.1532 13.6024C13.8991 13.8283 13.5809 13.9415 13.2619 13.9415C12.943 13.9415 12.6246 13.8286 12.3705 13.6033L3.41858 5.64581V8.42735H2.52374V4.84797C2.52374 4.35357 2.92418 3.95312 3.41858 3.95312H23.1052ZM12.9648 12.9339C13.1334 13.0835 13.3891 13.0842 13.559 12.933L22.6551 4.84797H3.86863L12.9648 12.9339Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingLink);
export default __webpack_public_path__ + "static/media/billingLink.bc23d476ce82140802010b3a37250abb.svg";
export { ForwardRef as ReactComponent };